import * as tslib_1 from "tslib";
import { BaseLicensePage } from '@components/shared/license/base.license.page';
import { TenantLicenseModalComponent } from '@pages/host/tenants/license/tenant-license.modal';
import { ModalService } from '@services';
import { merge } from 'rxjs';
var HostLicensePageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(HostLicensePageComponent, _super);
    function HostLicensePageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._modalService = _this._injector.get(ModalService);
        return _this;
    }
    HostLicensePageComponent.prototype.onRemove = function (payload) {
        this._onRemove(payload.deactivate);
    };
    HostLicensePageComponent.prototype.allocateLicenses = function () {
        var _this = this;
        var modalRef = this._modalService
            .openModal(TenantLicenseModalComponent, null, {
            data: {
                readonly: false,
                closeAfterAllocation: false,
            },
            size: 'sm',
            additionalClasses: ['allocate-license-modal'],
        });
        merge(modalRef.customEvent, // TODO: check this
        modalRef.afterClosedResult())
            .subscribe(function (res) {
            if (res.type === 2 /* Update */) {
                _this._cd.detectChanges();
            }
            else if (res.type === 5 /* Failed */) {
                _this.openDeactivateOfflineModal(res.additionalData.tenantId);
            }
        });
    };
    return HostLicensePageComponent;
}(BaseLicensePage));
export { HostLicensePageComponent };
